import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import Icon from '../components/Icon';
import useReveal from '../hooks/useReveal';
import { services } from '../mock/mock';

export default function Services() {
  useReveal();
  return (
    <div className="pt-20">
      <section className="bg-cream pt-20 pb-16 text-center">
        <div className="max-w-2xl mx-auto px-5">
          <p className="eyebrow text-sage-500 mb-3">{services.eyebrow}</p>
          <h1 className="text-5xl md:text-6xl font-serif font-bold text-ink mb-4">{services.title}</h1>
          <p className="text-ink/60 text-lg">{services.subtitle}</p>
        </div>
      </section>

      <section className="py-24">
        <div className="max-w-[1200px] mx-auto px-5">
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-7">
            {services.items.map((s, i) => (
              <div key={s.title} className="group bg-white border border-cream-dark rounded-2xl p-8 shadow-[0_2px_18px_rgba(0,0,0,0.04)] hover:shadow-xl hover:-translate-y-1 transition-all reveal" style={{ transitionDelay: `${(i % 3) * 80}ms` }}>
                <div className="w-14 h-14 rounded-xl bg-sage-50 flex items-center justify-center mb-6 transition-colors group-hover:bg-sage-100">
                  <Icon name={s.icon} size={26} className="text-sage-600" />
                </div>
                <h3 className="text-2xl font-serif text-ink mb-3">{s.title}</h3>
                <p className="text-ink/65 leading-relaxed mb-5">{s.text}</p>
                <Link to={s.to} className="inline-flex items-center gap-2 text-sage-600 font-semibold text-sm group/link">
                  More info <ArrowRight size={16} className="transition-transform group-hover/link:translate-x-1" />
                </Link>
              </div>
            ))}
          </div>
          <div className="mt-14 text-center reveal">
            <Link to="/contact" className="inline-flex items-center gap-2 bg-sage-500 hover:bg-sage-600 text-white font-semibold px-8 py-3.5 rounded-full transition-all hover:-translate-y-0.5 hover:shadow-lg">
              Book an appointment <ArrowRight size={18} />
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}
